import React from 'react';
import CityPage from './CityPage';

const MobileCarWashAbuDhabi = () => <CityPage cityId="abu-dhabi" />;

export default MobileCarWashAbuDhabi;
